import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Menu, { menuClasses } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import useBlendableImage from '~/hooks/image/useBlendableImage';
import { cutUID } from '~/utils/string';

export function BlendImageSelector() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const { blendableImages, handleChangeBlendedImage } = useBlendableImage();

    return (
        blendableImages?.length > 0 && (
            <Box position="relative" px={2} mt={1} mb={-0.5}>
                <Button
                    fullWidth
                    aria-controls="blend-image-menu"
                    aria-haspopup="true"
                    size="small"
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    sx={{
                        textTransform: 'capitalize',
                        justifyContent: 'flex-start',
                        width: 'calc(100% + 8px)',
                        ml: -0.5,
                        border: anchorEl
                            ? '1px solid'
                            : '1px solid transparent',
                    }}
                    endIcon={
                        <ExpandMoreIcon
                            sx={{
                                position: 'absolute',
                                right: 4,
                                top: 6,
                                transform: anchorEl
                                    ? 'rotate(180deg)'
                                    : 'rotate(0deg)',
                            }}
                        />
                    }
                >
                    Blend image
                </Button>
                <Menu
                    id="blend-image-menu"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    sx={{
                        width: 'calc(240px + 8px)',
                        ml: -0.5,
                        [`& .${menuClasses.paper}`]: {
                            width: '240px',
                            marginTop: '4px',
                        },
                    }}
                    MenuListProps={{ dense: true }}
                >
                    {blendableImages.map(({ image, registration }) => (
                        <MenuItem
                            key={image.dicomUid}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                            onClick={() => {
                                handleChangeBlendedImage(image, registration);
                            }}
                        >
                            <Box width="100%" overflow="hidden">
                                <Typography
                                    color="white"
                                    fontSize={14}
                                    sx={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {image.seriesMetadata.seriesDescription ??
                                        'Unknown Series'}
                                </Typography>
                                <Box display="flex" gap={0.5}>
                                    <Typography
                                        variant="body2"
                                        fontSize={12}
                                        color={'textSecondary'}
                                    >
                                        {image.seriesMetadata.modality}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        fontSize={12}
                                        color="textSecondary"
                                    >
                                        - {cutUID(image.seriesUid, 4, 4)}{' '}
                                    </Typography>
                                </Box>
                            </Box>
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
        )
    );
}
